import * as React from "react";
const SymbolUnavailable = ({
  d
}) => {
  return /*#__PURE__*/React.createElement("path", {
    className: "fill-ink-light-hover",
    d: d
  });
};
export default SymbolUnavailable;